import React from 'react';
import { FaCode, FaShieldAlt, FaMobile, FaChartBar, FaPalette, FaRobot } from 'react-icons/fa';

const About = () => {
  const services = [
    {
      icon: <FaCode className="text-4xl text-primary mb-4" />,
      title: 'Web Development',
      description: 'Full-stack web development using modern technologies and frameworks.'
    },
    {
      icon: <FaMobile className="text-4xl text-primary mb-4" />,
      title: 'Mobile Development',
      description: 'Native Android and cross-platform mobile app development.'
    },
    {
      icon: <FaShieldAlt className="text-4xl text-primary mb-4" />,
      title: 'Cybersecurity',
      description: 'Advanced security solutions and penetration testing services.'
    },
    {
      icon: <FaChartBar className="text-4xl text-primary mb-4" />,
      title: 'Data Analytics',
      description: 'Data analysis, visualization, and business intelligence solutions.'
    },
    {
      icon: <FaPalette className="text-4xl text-primary mb-4" />,
      title: 'UX/UI Design',
      description: 'User-centered design solutions for web and mobile applications.'
    },
    {
      icon: <FaRobot className="text-4xl text-primary mb-4" />,
      title: 'AI/ML Solutions',
      description: 'Artificial Intelligence and Machine Learning implementations.'
    }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">About Me</h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            As an accomplished professional aiming for significant achievements in the technology era, 
            I possess extensive experience and accomplishments in both technology and non-technology fields. 
            With advanced expertise particularly in cybersecurity and Android development, I am the founder 
            of an IT services company providing free services. Our company delivers the services listed below, 
            operating with a mission to benefit society. We aim to make technology accessible to everyone 
            through software development, digital security solutions, and open-source supported systems. 
            With our volunteer-based structure, we actively provide services in areas such as consulting 
            and technical support for both individuals and organizations.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index} 
              className="p-6 bg-gray-50 rounded-lg text-center hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1"
            >
              {service.icon}
              <h3 className="text-xl font-semibold text-gray-900 mb-2">{service.title}</h3>
              <p className="text-gray-600">{service.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <a
            href="https://nexora.imranmelikov.org"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-6 py-3 bg-primary text-white font-medium rounded-lg hover:bg-primary/90 transition-all duration-200 transform hover:scale-105"
          >
            Visit Company Website
            <svg className="ml-2 -mr-1 w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  );
};

export default About; 